/* eslint-disable no-param-reassign */

import {MESSAGE_SENT} from '../data/messageTypes';

export const GET_SENT_MESSAGES_PENDING = 'GET_SENT_MESSAGES_PENDING';
export const GET_SENT_MESSAGES_FULFILLED = 'GET_SENT_MESSAGES_FULFILLED';
export const GET_SENT_MESSAGES_REJECTED = 'GET_SENT_MESSAGES_REJECTED';
export const POST_MESSAGES_PENDING = 'POST_MESSAGES_PENDING';
export const POST_MESSAGES_FULFILLED = 'POST_MESSAGES_FULFILLED';
export const POST_MESSAGES_REJECTED = 'POST_MESSAGES_REJECTED';
export const GET_MESSAGES_PENDING = 'GET_MESSAGES_PENDING';
export const GET_MESSAGES_FULFILLED = 'GET_MESSAGES_FULFILLED';
export const GET_MESSAGES_REJECTED = 'GET_MESSAGES_REJECTED';

export default function reducer(state = {
  fetching: false,
  fetched: false,
  sentFetching: false,
  sentFetched: false,
  errors: {},
  messages: [],
  sentMessages: [],
  unreadMessagesCount: 0,
}, action) {
  switch (action.type) {
    case GET_MESSAGES_PENDING: {
      return {...state, fetching: true, fetched: false};
    }
    case GET_SENT_MESSAGES_PENDING: {
      return {...state, sentFetching: true, sentFetched: false};
    }
    case GET_MESSAGES_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        messages: action.payLoad.data,
      };
    }
    case GET_SENT_MESSAGES_FULFILLED: {
      return {
        ...state,
        sentFetching: false,
        sentFetched: true,
        sentMessages: action.payLoad.data,
      };
    }
    case 'MARK_MESSAGES_FULFILLED': {
      const messages = [...state.messages];
      messages.forEach((message) => {
        if (action.payLoad.messageIds.find(id => id === message.id)) {
          message.attributes.read = action.payLoad.read;
        }
      });

      return {
        ...state,
        messages
      };
    }

    case 'DECREMENT_UNREAD_MESSAGE_COUNT': {
      return {
        ...state,
        unreadMessagesCount: state.unreadMessagesCount === 0 ? 0 : ((state.unreadMessagesCount - action.payLoad) || 0)
      };
    }

    case 'INCREMENT_UNREAD_MESSAGE_COUNT': {
      return {
        ...state,
        unreadMessagesCount: state.unreadMessagesCount === 0
          ? state.unreadMessagesCount : ((state.unreadMessagesCount + action.payLoad) || 0)
      };
    }
    case 'DELETE_MESSAGES_FULFILLED': {
      let {messages, sentMessages} = state;

      if (action.payLoad.type === MESSAGE_SENT) {
        sentMessages = state.sentMessages.filter(message => !action.payLoad.messageIds.find(id => id === message.id));
      } else {
        messages = state.messages.filter(message => !action.payLoad.messageIds.find(id => id === message.id));
      }

      return {
        ...state,
        messages,
        sentMessages
      };
    }
    case 'GET_MESSAGES_REJECTED': {
      return {...state, errors: action.payLoad.errors};
    }
    case 'GET_UNREAD_MESSAGE_COUNT': {
      return {...state, unreadMessagesCount: action.payLoad.unread_messages};
    }
    default:
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/messagesReducer.js